export default __webpack_public_path__ + "static/media/xcovers-2-lqMAX.56b4a5a7.jpg";